import React, { useState } from "react";
import { useDropzone } from "react-dropzone";

export default function FileUpload({ setFieldValue, fieldName, imgUrl }) {
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [".jpeg", ".png", ".jpg"],
    },
    onDrop: (acceptedFiles) => {
      const fileReaders = acceptedFiles.map((file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(file);
        });
      });

      Promise.all(fileReaders).then((base64Files) => {
        setUploadedFiles(acceptedFiles);
        setFieldValue(fieldName, base64Files);
      });
    },
  });

  const removeFile = (fileToRemove) => () => {
    const updatedFiles = uploadedFiles.filter((file) => file !== fileToRemove);
    setUploadedFiles(updatedFiles);
  };

  return (
    <>
      <div className="usa-form-group" {...getRootProps()}>
        <div
          className="usa-file-input"
          style={{
            padding: "1rem",
            background: "#f8fafc",
            borderRadius: "0.5rem",
            border: "1px solid #ddd",
            textAlign: "center",
            position: "relative",
          }}
        >
          <input {...getInputProps()} />
          {uploadedFiles.length > 0 ? (
            uploadedFiles.map((file, index) => (
              <div key={index}>
                <img
                  src={URL.createObjectURL(file)}
                  alt={file.name}
                  style={{ height: "105px", maxWidth: "100%" }}
                />
                <p className="usa-hint margin-top-1">
                  Click here to change or upload a new image.
                </p>
              </div>
            ))
          ) : imgUrl?.length > 0 ? (
            typeof imgUrl !== "object" ? (
              <div>
                <img
                  src={imgUrl}
                  className="saved-img"
                  style={{ height: "105px", maxWidth: "100%" }}
                  alt="Uploaded"
                />
                <p className="usa-hint margin-top-1">
                  Click here to change or upload a new image.
                </p>
              </div>
            ) : (
              <>
                <div className="text-center margin-top-3">
                  <i className="fas fa-cloud-upload-alt fa-3x text-primary"></i>
                  <p className="usa-hint margin-top-1">
                    Drag and drop files here or click to browse.
                  </p>
                </div>
              </>
            )
          ) : (
            <>
              <div className="text-center margin-top-3">
                <i className="fas fa-cloud-upload-alt fa-3x text-primary"></i>
                <p className="usa-hint margin-top-1">
                  Drag and drop files here or click to browse.
                </p>
              </div>
            </>
          )}
        </div>
      </div>

      {uploadedFiles.map((file, index) => (
        <button
          key={index}
          onClick={removeFile(file)}
          className="usa-button usa-button--unstyled"
          style={{
            color: "#e53131",
            fontSize: "1.5rem",
            position: "absolute",
            right: "20px",
            top: "40px",
            zIndex: "9999",
            cursor: "pointer",
          }}
          aria-label="Remove uploaded file"
        >
          ✖
        </button>
      ))}
    </>
  );
}
